export const PSObjOne = {
    lightBg : true,
    lightText : false,
    lightTextDesc : false,
    topLine : 'Capacity Building',
    headline : 'Technology and Entrepreneurship Training',
    description : 'Technology and Etrepreneurship is our key area of specilization ' + 
    'In conjunction with the Federal Ministry of Humanitarian Affairs, Disaster Management  ' +
    'and Social Development, we recently trained about 3,000 N-Power beneficiaries of ' +
    'Kaduna State',
    buttonLabel : 'More Details',
    imgStart : 'start',
    img : '../../nPowerLogo.png',
    alt: 'N Power'
}